module.exports = __webpack_public_path__ + "img/c04_unittakebara_Normal_ua.889e82a1.webp";